<script setup>
import {computed, ref} from "vue";

const props = defineProps({
    content: {
        type: Object,
        required: true,
    },
})

const headingScale = ref(1)
const lineHeightScale = ref(1)

const fontSizeStyle = computed(() => {
    if (! props.content.customFontSize || props.content.customFontSize === '100%') {
        return '';
    } else {
        headingScale.value = parseFloat(props.content.customFontSize.replace('%', '')) / 100;
        return {fontSize: props.content.customFontSize};
    }
})

const lineHeightStyle = computed(() => {
    if (! props.content.customLineHeight || props.content.customLineHeight === '100%') {
        return {lineHeight: '1.55em'};
    } else {
        lineHeightScale.value = parseFloat(props.content.customLineHeight.replace('%', '')) / 100;
        return {lineHeight: (1.55 * props.content.customLineHeight.replace('%', ''))+'%'};
    }
})

</script>
<template>
    <div>
        <div
            :class="'text-' + props.content?.alignment"
            v-html="props.content?.text"
            :style="[fontSizeStyle, lineHeightStyle]"
        ></div>
    </div>
</template>

<style scoped>
:deep(ul) {
    list-style-type: disc;
    padding-left: 1em;
}
:deep(ol) {
    list-style-type: decimal;
    padding-left: 1em;
}

div {
    --heading-scale: v-bind(headingScale);
    --line-height-scale: v-bind(lineHeightScale);
}
</style>
